var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61054 33.9992H0.561607V11.2997H7.61054V33.9992ZM4.08228 8.20326C1.82826 8.20326 0 6.3363 0 4.08228C1.61333e-08 2.99959 0.430096 1.96125 1.19567 1.19567C1.96125 0.430096 2.99959 0 4.08228 0C5.16496 0 6.20331 0.430096 6.96888 1.19567C7.73446 1.96125 8.16455 2.99959 8.16455 4.08228C8.16455 6.3363 6.33554 8.20326 4.08228 8.20326ZM33.9924 33.9992H26.9587V22.9492C26.9587 20.3158 26.9055 16.9385 23.2938 16.9385C19.6289 16.9385 19.0673 19.7997 19.0673 22.7595V33.9992H12.026V11.2997H18.7865V14.3961H18.8852C19.8263 12.6126 22.125 10.7305 25.5546 10.7305C32.6886 10.7305 34 15.4283 34 21.53V33.9992H33.9924Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f4b0249b51fe5f5f879a1f1f131c1d35.svg";
export { ForwardRef as ReactComponent };